import { RouteConfig } from "vue-router";

const cajaChicasLinares: RouteConfig = {
  path: "/cajaChicasLinares",
  name: "cajaChicasLinares",
  component: () => import(/* webpackChunkName: "caja-chicas-linares" */ "@/views/CajaChicasLinares.vue"),
};

export default cajaChicasLinares;
